// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__2yiAz","upload":"Small_upload__2JRzn","imageWrap":"Small_imageWrap__CpMtu","removeBtn":"Small_removeBtn__f4A2Y"};